import Splide from '@splidejs/splide';

const partnerSlider = document.querySelector('.splide.partner-logos');

if (partnerSlider) {
    new Splide(partnerSlider, {
        type : 'loop',
        rewind : true,
        height : '230px',
        fixedWidth : '230px',
        perPage : 5,
        perMove: 1,
        focus : 'center',
        gap : '50px',
        arrows : false,
        autoplay: true,
        breakpoints : {
            640: {
                perPage : 1
            }
        }
    }).mount();
}